<template>
    <modal class="modal-cash-out" v-model="viewOn" v-bind:title="cashier" size="sm" v-on:show="onShow">
        <div class="container-fluid">
            <form class="form-horizontal" @submit.prevent="transfer" v-if="cashier=='BEECASH'">
                <div class="from-group">
                    <label class="control-label col-sm-2" for="caBrands">FROM</label>
                    <div class="input-hold col-sm-10" id="caBrands">
                        <select v-model="sender">
                            <option v-for="card in cards" v-bind:value="card.id">{{card.id}}</option>
                        </select>
                    </div>
                </div>
                <div class="from-group">
                    <label class="control-label col-sm-2" for="div-amount">BALANCE</label>
                    <div class="input-hold col-sm-10" id="div-balance">
                        <input type="text" v-bind:value="balance" class="" id="input-balance" name="uName"
                               placeholder="" required readonly>
                    </div>
                </div>
                <div class="from-group">
                    <label class="control-label col-sm-2" for="div-amount">AMOUNT</label>
                    <div class="input-hold col-sm-10" id="div-amount">
                        <input type="text" v-model="amount.value" class="" id="uName" name="uName" placeholder=""
                               required>
                        <label id="uName-error" class="error" for="uName" v-if="amount.error">{{amount.error}}</label>
                    </div>
                </div>
                <div class="form-control progress progress-control" v-if="working">
                    <div class="progress-bar progress-bar-success progress-bar-striped active progress-transfer"
                         role="progressbar"
                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <label class="error general-error" v-if="error">{{error}}</label>
                <div class="col-sm-offset-2 col-xs-offset-2 col-sm-4 col-xs-8">
                    <button type="submit" class="btn btn-default" v-bind:disabled="cards.length==0 || working">Transfer</button>
                </div>
            </form>

            <form class="form-horizontal" @submit.prevent="checkout" v-if="cashier=='PAYSAFE' && entity==''">
                <div class="from-group">
                    <label class="control-label col-sm-2" for="div-amount">AMOUNT</label>
                    <div class="input-hold col-sm-10">
                        <input type="text" v-model="amount.value" class="" name="uName" placeholder=""
                               required>
                        <label class="error" for="uName" v-if="amount.error">{{amount.error}}</label>
                    </div>
                </div>
                <div class="form-control progress progress-control" v-if="working">
                    <div class="progress-bar progress-bar-success progress-bar-striped active progress-transfer"
                         role="progressbar"
                         aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <label class="error general-error" v-if="error">{{error}}</label>
                <div class="col-sm-offset-2 col-sm-2">
                    <button type="submit" class="btn btn-default" v-bind:disabled="working">
                        Continue
                    </button>
                </div>
            </form>
            <!--<div v-if="entity">
                <iframe v-if="entity" v-bind:src="'paysafe.html?entityId='+entity" style="border: none"></iframe>
            </div>-->
        </div>
        <div slot="footer">
            <btn @click="setCategory('BEECASH')" v-bind:class="{ 'active': cashier=='BEECASH'}">BEECASH</btn>
            <btn @click="setCategory('PAYSAFE')" v-bind:class="{ 'active': cashier=='PAYSAFE'}">PAYSAFE</btn>
        </div>
    </modal>
</template>

<script>
    export default {
        props: ['view'],
        name: 'pay-in',
        dependencies: ['service'],
        data: function () {
            return {
                sender: '',
                cards: [],
                amount: {
                    value: 0, error: '', validator: {
                        rules: {
                            required: true,
                            max: 0,
                            format: 'number'
                        },
                        messages: {
                            required: "Please provide a password",
                            max: "Amount is to big",
                            format: "Illegal number format"
                        }
                    }
                },
                error: '',
                working: false,
                cashier: 'BEECASH',
                entity: ''
            }
        },
        mounted() {
            window.onmessage = e => {
                if (e.data === 'pay-safe-close') {
                    this.viewOn = false;
                    this.$emit('status-change');
                }
            };
        },
        computed: {
            viewOn: {
                get: function () {
                    return this.view
                },
                set: function (value) {
                    this.$emit('view-change', value)
                }
            },
            balance: function () {
                let card = this.cards.find(v => v.id == this.sender);
                this.amount.value = card ? card.balance : 0;
                return card ? card.balance : '';
            }
        },
        methods: {
            onShow() {
                this.setCategory('BEECASH');
            },
            transfer() {
                this.error = '';
                if (!this.validate(this.amount)) return;
                this.working = true;
                this.service.transfer(this.sender, this.amount.value).then(r => {
                    if (r.data.errorCode == 0) {
                        this.viewOn = false;
                        this.$emit('balance-change');
                    } else
                        this.error = r.data.description;
                }).catch(e => {
                    if (e.response)
                        if (e.response.data)
                            if (e.response.data.description) {
                                this.error = e.response.data.description;
                                return;
                            }
                    this.error = 'General error';
                }).finally(() => this.working = false);
            },
            validate: (field) => {
                field.error = '';
                let rules = field.validator.rules;
                let messages = field.validator.messages;
                for (let rule in rules) {
                    if (rule === 'required' && rules[rule]) {
                        if (!field.value) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'minlength') {
                        if (field.value.length < rules[rule]) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'max') {
                        let number = Number(field.value);
                        if (number > rules[rule]) {
                            field.error = messages[rule];
                            return false;
                        }
                    } else if (rule === 'format') {
                        let number = Number(field.value)
                        if (rules[rule] == 'number' && isNaN(number)) {
                            field.error = messages[rule];
                            return false;
                        }
                    }
                }
                return true;
            },
            checkout() {
                this.working = true;
                this.service.checkout(this.amount.value).then(r => {
                    if (r.data.errorCode == 0) {
                        this.entity = r.data.id;
                        let params = new URLSearchParams({entityId: this.entity, url: r.data.url});
                        let address = 'paysafe.html?' + params;
                        console.log('address ', address);
                        let newWin = window.open('paysafe.html?' + params, 'pay-safe', 'width=600,height=400');
                        /*let id = setInterval(()=>{
                            if(newWin.closed) {
                                this.viewOn = false;
                                clearInterval(id);
                            }
                        }, 1000);*/
                    } else
                        this.error = r.data.description;
                }).catch(e => {
                    this.error = 'General error';
                    if (e.response) {
                        this.error = e.response.data.description || 'General error';
                    }
                }).finally(() => this.working = false);
            },
            initBeeCash() {
                this.error = '';
                this.cards = [];
                this.amount.value = 0;
                this.amount.error = '';
                this.working = true;
                this.service.cards().then(r => {
                    if (r.data.errorCode == 0) {
                        this.cards = r.data.cards;
                        this.sender = this.cards[0].id;
                        this.amount.value = this.cards[0].balance;
                        this.amount.validator.rules.max = this.cards[0].balance;
                    } else
                        this.error = r.data.description;
                }).catch(e => {
                    if (e.response) {
                        this.error = e.response.data.description;
                    }
                }).finally(() => this.working = false);
            },
            initPaySafe() {
                this.error = '';
                this.amount.value = 0;
                this.amount.validator.error = '';
                this.entity = '';
            },
            setCategory(category) {
                this.cashier = category;
                if (category == 'BEECASH')
                    this.initBeeCash();
                else if (category == 'PAYSAFE')
                    this.initPaySafe();

            }
        }
    }
</script>

<style scoped>

</style>